import React from "react";
import Placeholder from "../../../../core-components/Shimmer/ShimmerUI";
import * as S from "./FiltersLoader.styles";

const FiltersLoaderUI = () => {
  return (
    <S.FiltersCont>
      <div className="filtersHeading">
        <div className="makeFlex spaceBetween hrtlCenter">
          <Placeholder
            ldrWidth="10.4rem"
            ldrHeight="3rem"
            margin="0 0 0.9rem 0"
          />
          <span className="clearText"></span>
        </div>
        <Placeholder ldrWidth="173px" ldrHeight="1.8rem" margin="0 0 0 0" />
      </div>
      <ul className="segmentWrap">
        <Placeholder
          ldrWidth="250px"
          ldrHeight="3rem"
          margin="0 2.5rem 1.3rem 0"
        />
        <Placeholder
          ldrWidth="250px"
          ldrHeight="6rem"
          margin="0 2.5rem 1.3rem 0"
        />
        <Placeholder
          ldrWidth="250px"
          ldrHeight="6rem"
          margin="0 2.5rem 1.3rem 0"
        />
        <Placeholder
          ldrWidth="250px"
          ldrHeight="6rem"
          margin="0 2.5rem 1.3rem 0"
        />
      </ul>
      <S.LoadingFilters>
        <li>
          <Placeholder
            ldrWidth="257px"
            ldrHeight="1.8rem"
            margin="0 0 2.2rem 0"
          />
          <ul>
            {[1, 2, 3, 4].map((index) => (
              <li>
                <Placeholder
                  ldrWidth="1.9rem"
                  ldrHeight="1.8rem"
                  margin="0 1.1rem 1.4rem 0"
                />
                <Placeholder
                  ldrWidth="13.9rem"
                  ldrHeight="1.8rem"
                  margin="0 0 1.3rem 0"
                />
              </li>
            )) || null}
          </ul>
        </li>
        <li>
          <Placeholder
            ldrWidth="257px"
            ldrHeight="1.8rem"
            margin="0 0 2.2rem 0"
          />
          <ul>
            {[1, 2, 3, 4].map((index) => (
              <li key={`placeolder${index}`}>
                <Placeholder
                  ldrWidth="1.9rem"
                  ldrHeight="1.8rem"
                  margin="0 1.1rem 1.4rem 0"
                />
                <Placeholder
                  ldrWidth="13.9rem"
                  ldrHeight="1.8rem"
                  margin="0 0 1.3rem 0"
                />
              </li>
            )) || null}
          </ul>
        </li>
        <li>
          <Placeholder
            ldrWidth="257px"
            ldrHeight="1.8rem"
            margin="0 0 2.2rem 0"
          />
          <ul>
            {[1, 2, 3, 4].map((index) => (
              <li key={`placeolder${index}`}>
                <Placeholder
                  ldrWidth="1.9rem"
                  ldrHeight="1.8rem"
                  margin="0 1.1rem 1.4rem 0"
                />
                <Placeholder
                  ldrWidth="13.9rem"
                  ldrHeight="1.8rem"
                  margin="0 0 1.3rem 0"
                />
              </li>
            )) || null}
          </ul>
        </li>
        <li>
          <Placeholder
            ldrWidth="257px"
            ldrHeight="1.8rem"
            margin="0 0 2.2rem 0"
          />
          <ul>
            {[1, 2, 3, 4].map((index) => (
              <li key={`placeolder${index}`}>
                <Placeholder
                  ldrWidth="1.9rem"
                  ldrHeight="1.8rem"
                  margin="0 1.1rem 1.4rem 0"
                />
                <Placeholder
                  ldrWidth="13.9rem"
                  ldrHeight="1.8rem"
                  margin="0 0 1.3rem 0"
                />
              </li>
            )) || null}
          </ul>
        </li>
      </S.LoadingFilters>
    </S.FiltersCont>
  );
};

export default FiltersLoaderUI;


